

















































import { Component, Vue, Watch } from "vue-property-decorator";
import { purePcVerify } from "@/req/homes";

@Component({
  components: {},
})
export default class Home extends Vue {
  public modal = false;
  public code = "";
  public certificateData: any = {};
  public certificateModal = false;
  public show() {
    this.modal = true;
  }
  public async search() {
    const res = await purePcVerify({
      code: this.code,
    });
    if (res.code == 200) {
      res.data.effect_start_at = res.data.effect_start_at.substring(0, 10);
      res.data.effect_end_at = res.data.effect_end_at.substring(0, 10);
      this.certificateData = res.data
      this.certificateData.issued = this.certificateData.effect_start_at.replaceAll('-', '.');
      this.modal = false;
      this.certificateModal = true;
    } else {
      this.$Message.error(res.msg);
    }
  }
  public cancel() {
    this.code = "";
    this.certificateModal = false;
    this.modal = false;
  }
}
